export const CIDR_BLOCK_ALLOW_ALL = '0.0.0.0/0'
export const CIDRToolTip = (mandatory: boolean, entity: 'Input' | 'Output') =>
  `Specifies which IP addresses are allowed to connect to this ${entity}. Example: 10.0.0.0/16. ${
    mandatory
      ? `To allow everything use ${CIDR_BLOCK_ALLOW_ALL}`
      : `To allow everything, leave blank or use ${CIDR_BLOCK_ALLOW_ALL}.`
  }`
